import { ref } from 'vue'

const loadingCount = ref(0)
const isLoading = ref(false)

let delayTimeout = null
const MIN_LOADING_DURATION = 100 // milisegundos

export function useGlobalLoading() {
  const startLoading = () => {
    loadingCount.value++

    // Mostrar loader si es el primero
    if (loadingCount.value === 1) {
      if (delayTimeout) {
        clearTimeout(delayTimeout)
        delayTimeout = null
      }
      isLoading.value = true
    }
  }

  const stopLoading = () => {
    loadingCount.value = Math.max(loadingCount.value - 1, 0)

    if (loadingCount.value === 0) {
      if (delayTimeout) clearTimeout(delayTimeout)

      delayTimeout = setTimeout(() => {
        if (loadingCount.value === 0) {
          isLoading.value = false
        }
      }, MIN_LOADING_DURATION)
    }
  }

  return {
    isLoading,
    startLoading,
    stopLoading
  }
}
